import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CibilRequest, CibilResponse } from "../../model/cibil/cibil-service.model";
import { ConfigService } from "../config.service";

@Injectable()
export class CibilService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getCibilReport(requestData: CibilRequest): Promise<CibilResponse> {
        const url = `${this.configService.getCreditBureauServiceUrl()}/credit-report?source=CIBIL`;
        return await this.httpClient.post<CibilResponse>(url, requestData).toPromise();
    }
}